import { CultureInfo } from '../culture-info.model';
import { CultureInfoDe } from './de';

/**
 * @ignore
 */
export const CultureInfoDeLU: CultureInfo = {
  name: 'de-LU',
  displayName: 'German (Luxembourg)',
  iso3LanguageCode: 'deu',
  iso2LanguageCode: 'de',
  ietfLanguageTag: 'de-LU',
  parent: CultureInfoDe
};
